import React, { useState } from 'react';
import { UserContextModal } from 'src/auth/types/UserContextTypes';
import {
  APP_CONTAINER_BASE_URL,
  CONFIG_TYPE,
  UI_CLIENTS,
} from 'src/constants/GlobalConstants';
import { fetchFromAppConfig } from 'src/config-store/ConfigFetcher';

export interface IAuthContext extends UserContextModal {
  setPreferredAccountId: Function;
  appContainerBaseUrl: APP_CONTAINER_BASE_URL; //Request comes from /hrecomplains or /regulatorCentral
}

export const initialAuthContext: IAuthContext = Object.freeze({
  emailId: '',
  customerId: '',
  customerFullName: '',
  accountAttributes: [],
  preferredAccountId: '',
  clientId: UI_CLIENTS.VICI,
  isAnonymousUser: false,
  appContainerBaseUrl: APP_CONTAINER_BASE_URL.REGULATOR_CENTRAL,
  setPreferredAccountId: () => {},
  ddmIntakeFormSchemaId: '',
});

export const AuthContext =
  React.createContext<IAuthContext>(initialAuthContext);

export interface IAuthProvider {
  authContext: IAuthContext;
  children: React.ReactElement;
}

const AuthProvider = ({ children, authContext }) => {
  const accumulatedAuthContext: IAuthContext = authContext
    ? authContext
    : initialAuthContext;
  const [preferredAccountId, setPreferredAccountId] = useState(
    accumulatedAuthContext.preferredAccountId,
  );

  const ddmIntakeFormSchemaId = fetchFromAppConfig(
    preferredAccountId,
    accumulatedAuthContext.clientId,
    CONFIG_TYPE.PROPERTIES,
  )?.ddmIntakeFormSchemaId;

  const updatedAuthContext = {
    ...accumulatedAuthContext,
    preferredAccountId,
    setPreferredAccountId,
    ddmIntakeFormSchemaId: ddmIntakeFormSchemaId || preferredAccountId,
  };

  return (
    <AuthContext.Provider value={updatedAuthContext}>
      {children}
    </AuthContext.Provider>
  );
};
export default AuthProvider;
